import { formatDate } from '@angular/common'
import { ChangeDetectorRef, Component, Inject } from '@angular/core'
import { MatDialogRef, MatSnackBar, MatTabChangeEvent, MAT_DIALOG_DATA } from '@angular/material'
import { Observable, Subject } from 'rxjs'
import { BaseDialogComponent } from '../../../../../../base/dialog-base/dialog-base.component'
import { NomadeService } from '../../../../../../nomade/services/nomade.service'
import { DialogService } from '../../../../../../services'


@Component({
	selector: 'atyl-nomade-form-dialog',
	templateUrl: './form-dialog.component.html',
	styleUrls: ['./form-dialog.component.scss']
})
export class FormDialogComponent extends BaseDialogComponent {

	naviagations: any[] = [];
	atylDemand: any
	atylDossier: any
	atylVisite: any
	
	private childs:any[]=[];
	private childsIndex:any[]=[];
	
	private IDNomade:string;
    private nomadeForm: any = false;

    private saveTriggerSubject = new Subject<any>();
    private tabFormIndexOld: number = 0;

    private formNomadeRequestes: any[] = [];
	
	constructor(
		dialogRef: MatDialogRef<FormDialogComponent>,
		changeDetectorRef: ChangeDetectorRef,
		dialogService: DialogService,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private nomadeService: NomadeService,
		private snackbar: MatSnackBar
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
		console.log( "FormDialogComponent init",this.data)
		this.atylDemand = this.data.form
		this.atylDossier = this.data.dossier
		
		if (this.data.visite)
		  	this.atylVisite=this.data.visite;
        //Modif formulaire créer dans le mode nomade
        if(this.data.nomadeForm){
            this.nomadeForm = this.data.nomadeForm;
            this.formNomadeRequestes = this.nomadeForm.underFormsReq;
        }
		
		this.IDNomade= this.nomadeForm? this.nomadeForm.nomadeId :this.newGuid();
		
		if (this.data && this.data.form && this.data.form.form) {
			console.log( "FormDialogComponent type",(this.data.form.form.under_form.length>0));
			this.childs=this.data.form.childs;
			for(let i:number=0;i<this.childs.length;i++) {
				if (this.childs[i].form) {
					this.childsIndex[this.childs[i].form.ID]=this.childs[i];
				}
			}
			if (this.data.form.form.under_form.length>0) {
			    
				this.data.form.form.under_form.forEach((element: any) => {
					var ell:any={};
					var idd:number=0;
					var ff:any=this.data;
					if (this.childsIndex[element.ID]!=undefined) {
						idd=this.childsIndex[element.ID].ID;
						ell=this.childsIndex[element.ID].form;
						ff=this.childsIndex[element.ID];
					} else {
						
						ell=element
					}	
					ell.my_demande={
						ID: idd ,
						parentID: this.atylDemand.ID,
						demande: ff
					}
					this.naviagations.push(ell)	
				})
			}
			else {
				var ell:any=this.data.form.form;
				ell.my_demande={
						ID: this.atylDemand.ID ,
						parentID: undefined,
						demande:this.data
					}
				this.naviagations.push(ell)
				
			}	
		}
	}
	
	newGuid() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0,
				v = c == 'x' ? r : (r & 0x3 | 0x8)
			return v.toString(16)
		})
	}
	
	submitForm(event: any) {
		let request = {
			method: 'webservice.formulaire:set',
			params: {},
            id:null
		}
		console.log("FormDialogComponent submitForm",event)
		const values = event.values
		const currentForm = event.form
		
		for (let key in values) {
			let value = values[key]
			if (/*Array.isArray(value) ||*/ value == '' || value == undefined) {
				values[key] = null
			}
		}
		
		this.atylDemand.documents = values.DOCUMENTS
		if (!values['close'])
			this.data.closeWhenValidate = false
		else if (values['close'])
			this.dialogService.closeAll()
			
		let damande_date_debut:string=null;
		if (values['demande_date_debut'] )	 {
			let dtd:string=formatDate(values['demande_date_debut'],'yyyy-MM-ddTHH:mm:ss', 'fr-FR');
			console.log('damande_date_debut',values['demande_date_debut'], dtd)
		//	damande_date_debut=new Date(dtd);
		 damande_date_debut=dtd
		}
		let damande_date_fin:string=null;
		if (values['demande_date_fin'])	{
			//damande_date_fin=values['demande_date_fin'];
			let dtf:string=formatDate(values['demande_date_fin'],'yyyy-MM-ddTHH:mm:ss', 'fr-FR');
			 damande_date_fin=dtf
		}	
			
		for (var i = 0; i < currentForm.fields.length; i++) {
			var field = currentForm.fields[i]
			if (values.hasOwnProperty(field.ID)) {
				var val = values[field.ID]

				if (field.field.type == 'date'  
				&& val!=null
				&& val!=undefined
				&& val != '') {
					
					var utcDate = formatDate(val, 'yyyy-MM-ddTHH:mm:ss', 'fr-FR')
					
					/*
					const regex = /\.000Z$/i;
					var utcDate=val.replace(regex, '');
					*/
					//console.log("date submit",field,utcDate,val);
					
					val = utcDate
				}	

/*
				if (field.field.type == 'date' && val != '') {
					var utcDate = formatDate(val, 'yyyy-MM-ddTHH:mm:ss', 'fr-FR')
					val = utcDate
				}
*/
				field['value'] = val
				currentForm.fields[i] = field
			}
		}
		
		
		var idd:number=this.atylDemand.ID;
		var parent:number=0;
		if (currentForm.my_demande!=undefined
		&& currentForm.my_demande.ID !=undefined)
			idd=currentForm.my_demande.ID
		if (currentForm.my_demande!=undefined
		&& currentForm.my_demande.parentID !=undefined)
			parent=currentForm.my_demande.parentID
		console.log("FormDialogComponent submitForm before",idd,parent,this.atylDemand.form.fields)	
		if (!idd) {
            var oldRequest = this.formNomadeRequestes.find(req=>req.params.type == currentForm.ID);
            if(oldRequest){
                //si on a déjà une requette sur ce formulaire, on va modifier les champs de l'existante
                oldRequest.params.options.fields = currentForm.fields;
                this.nomadeService.updateRequest(oldRequest,oldRequest.id);
            }
            else{
                request.params = {
                    type: currentForm.ID,
                    /*idForm: currentForm.key,*/
                    idDemande: idd,
                    options: {fields: currentForm.fields}
                }
                if (damande_date_debut) 
                      request.params["options"].demande_date_debut = damande_date_debut
                else{
                    
                }
                if (damande_date_fin)
                   request.params["options"].demande_date_fin = damande_date_fin 
                   
                if (this.atylVisite!=undefined && this.atylVisite )
                   request.params["options"].visiteNomade = this.atylVisite.ID   
                   
                if (parent>0)
                     request.params["options"].parent= parent;
                else{
                    request.params["options"].parentNomadeId= this.IDNomade;
                    if (this.atylDossier.id!=undefined)
                         request.params["options"].dossier=this.atylDossier.id;
                    if (this.atylDossier.dossierID!=undefined)
                         request.params["options"].dossier=this.atylDossier.dossierID;	
                     
                    if (this.atylDemand.demande!=undefined && this.atylDemand.demande.type!=undefined )
                         request.params["options"].demande_type=this.atylDemand.demande.type.ID;
                    if (this.atylDemand.form!=undefined){
                        request.params["options"].parentForm=this.atylDemand.form.ID;
                        request.params["options"].parentLibelle=this.atylDemand.form.libelle;
                    } 
                }
                this.snackbar.open('Onglet enregistré', 'Fermer', {
                    duration: 3300
                });
                this.nomadeService.addRequest(request).then(idRequete=>{
                    console.log('ID de la requête ajoutée :', idRequete);
                    request.id = idRequete,
                    this.formNomadeRequestes.push(request);
                });
            }       
            console.log("FormDialogComponent request0",request) 
		}
		else {
			request.params = {
				type: currentForm.ID,
				/*idForm: currentForm.key,*/
				idDemande: idd,
				options: {fields: currentForm.fields},
			}
			
			if (damande_date_debut)
			      request.params["options"].demande_date_debut = damande_date_debut
			      
			if (damande_date_fin)
			   request.params["options"].demande_date_fin = damande_date_fin 
			if (parent>0)
			     request.params["options"].parent= parent;
			if (this.atylVisite!=undefined && this.atylVisite )
			   request.params["options"].visiteNomade = this.atylVisite.ID     
			     
			console.log("FormDialogComponent request1",request)     
			this.snackbar.open('Onglet enregistré', 'Fermer', {
				duration: 3300
			})
			this.nomadeService.addRequest(request)
		}
	}

    handleTabChange(event: MatTabChangeEvent) {
        this.saveTriggerSubject.next(this.tabFormIndexOld);
        this.tabFormIndexOld = event.index;
    }
    

}
